import {
	handleActions
} from 'redux-actions';
import Immutable from 'immutable';

const LabelState = Immutable.fromJS({
	alertStyle: null,
	alertMessage: null,
	orderId: '',
	allOrderIds: [],
	eventKey: 0,
	careLabel: {
		orderId: '',
		careLabel: '',
		manufactureDate: ''
	},
	careLabelValidation: {
		orderId: {
			validationState: null,
			helpBlock: null
		},
		careLabel: {
			validationState: null,
			helpBlock: null
		},
		manufactureDate: {
			validationState: null,
			helpBlock: null
		},
	},
	noLabelGeneratedCount: '',
	statSerialNoDataList: null,
	specialNoteDownloadUrl: '',
	labelFormBean: {
		orderLabelId: null,
		serialNo: null,
		orderId: null,
		color: null,
		sizing: null,
		specialNote: null,
		manufactureDate: null,
		careLabel: null,
		colorValues: null,
		sizingValues: null
	},
	labelFormBeanValidation: {},
	alertSearchStyle: null,
	alertSearchMessage: null,
	serialNoDownloadUrl: '',
	deletedLogIds: [],
	labelRestoreFormBean: {
		orderId: null,
		deletedLogId: null
	}
});

const labelReducer = handleActions({
	CHANGE_LABEL_ORDERID: (state, { payload }) => {
		let careLabel = state.get('careLabel');
		return state.merge({
			orderId: payload.orderId,
			careLabel: careLabel.set('orderId', payload.orderId),
		})
	},
	FIND_ALL_ORDERIDS: (state, { payload }) => {
		return state.merge({
			allOrderIds: payload.data
		})
	},
	CHANGE_LABEL_EVENT_KEY: (state, { payload }) => {
		return state.merge({
			eventKey: payload
		})
	},
	CHANGE_CARELABEL_VALUE: (state, { payload }) => {
		let careLabel = state.get('careLabel');
		return state.merge({
			careLabel: careLabel.set(payload.id, payload.value),
		})
	},
	BEFORE_GENERATE_CARE_LABELS: (state, { payload }) => {
		return state.merge({
			alertStyle: null,
			alertMessage: '資料處理中，請稍後。'
		})
	},
	GENERATE_CARE_LABELS: (state, { payload }) => {
		return state.merge({
			careLabel: payload.data.bean,
			careLabelValidation: payload.data.valBean,
			alertStyle: payload.data.alertStyle,
			alertMessage: payload.data.alertMessage,
		})
	},
	DELETE_CARE_LABELS: (state, { payload }) => {
		return state.merge({
			alertStyle: payload.data.alertStyle,
			alertMessage: payload.data.alertMessage,
		})
	},
	RESTORE_CARE_LABELS: (state, { payload }) => {
		return state.merge({
			alertStyle: payload.data.alertStyle,
			alertMessage: payload.data.alertMessage,
		})
	},
	FIND_NOLABEL_GENERATED_COUNT: (state, { payload }) => {
		return state.merge({
			noLabelGeneratedCount: payload.data,
		})
	},
	FITTING_DEFAULT_VALIDATE_FAIL: (state, { payload }) => {
		return state.merge({
			alertStyle: 'danger',
			alertMessage: payload.displayMessage,
		})
	},
	FIND_SERIALNO_DATA: (state, { payload }) => {
		return state.merge({
			statSerialNoDataList: payload.data.statSerialNoDataList,
		})
	},
	EXPORT_SPECIAL_NOTE_LIST: (state, { payload }) => {
		return state.merge({
			specialNoteDownloadUrl: payload.data.bean.downloadUrl,
		})
	},
	CLEAR_SPECIAL_NOTE_DOWNLOADURL: (state, { payload }) => {
		return state.merge({
			specialNoteDownloadUrl: '',
		})
	},
	CLEAN_LABEL_ALERT: (state, { payload }) => {
		return state.merge({
			alertStyle: null,
			alertMessage: null,
			careLabelValidation: {}
		})
	},
	// FIND_ORDER_LABEL: (state, { payload }) => {
	// 	return state.merge({
	// 		alertStyle: null,
	// 		alertMessage: null,
	// 		careLabelValidation: {}
	// 	})
	// },
	// FIND_ORDER_LABEL: (state, { payload }) => {
	// 	return state.merge({
	// 		labelFormBean: payload.data
	// 	})
	// },
	FIND_ORDER_LABEL: (state, { payload }) => {
		if (payload.alertStyle === 'warning') {	//只顯示warning
			return state.merge({
				alertSearchStyle: payload.alertStyle,
				alertSearchMessage: payload.displayMessage,
				careLabelValidation: {},
				labelFormBean: payload.data,
				alertStyle: null,
				alertMessage: null
			})
		} else {
			return state.merge({
				alertSearchStyle: null,
				alertSearchMessage: null,
				careLabelValidation: {},
				labelFormBean: payload.data,
				alertStyle: null,
				alertMessage: null
			})
		}
	},
	CHANGE_LABEL_VALUE: (state, { payload }) => {
		let labelFormBean = state.get('labelFormBean');
		return state.merge({
			labelFormBean: labelFormBean.set(payload.id, payload.value),
		})
	},
	EDIT_ORDER_LABEL: (state, { payload }) => {
		return state.merge({
			labelFormBean: payload.data.bean,
			labelFormBeanValidation: payload.data.valBean,
			alertStyle: payload.data.alertStyle,
			alertMessage: payload.data.alertMessage,
		})
	},
	CLEAN_ORDER_LABEL_ALERT: (state, { payload }) => {
		return state.merge({
			alertStyle: null,
			alertMessage: null,
			alertSearchStyle: null,
			alertSearchMessage: null,
			labelFormBeanValidation: {}
		})
	},
	CLEAN_ORDER_LABEL_INPUT: (state, { payload }) => {
		return state.merge({
			alertStyle: null,
			alertMessage: null,
			labelFormBean: {
				orderLabelId: null,
				serialNo: null,
				orderId: null,
				color: null,
				sizing: null,
				specialNote: null,
				manufactureDate: null,
				careLabel: null
			},
			labelFormBeanValidation: {}
		})
	},
	EXPORT_SERIAL_NO_LIST: (state, { payload }) => {
		return state.merge({
			serialNoDownloadUrl: payload.data.bean.downloadUrl,
		})
	},
	CLEAR_SERIAL_NO_DOWNLOADURL: (state, { payload }) => {
		return state.merge({
			serialNoDownloadUrl: '',
		})
	},
	FIND_LABEL_DELETED_LOG_IDS: (state, { payload }) => {
		return state.merge({
			deletedLogIds: payload.data,
		})
	},
	CHANGE_LABEL_RESTORE_VALUE: (state, { payload }) => {
		let labelRestoreFormBean = state.get('labelRestoreFormBean');
		return state.merge({
			labelRestoreFormBean: labelRestoreFormBean.set(payload.id, payload.value),
		})
	},
}, LabelState);

export default labelReducer;


// WEBPACK FOOTER //
// ./src/reducers/labelReducer.js